import React, {useRef} from "react";
import HubspotForm from 'react-hubspot-form';

export const GrantFormOneSpanish = () => {
  const hubspotFormRef = useRef(null);

  return (
    <HubspotForm
      ref={hubspotFormRef}
      portalId='2784460'
      formId='7be9bdeb-fac1-42d5-a3b6-84864fb7fbdd'
      cssClass="position-relative contact-form"
      submitButtonClass="btn"
      loading={<div>Loading...</div>}
    />
  )
}